<template>
    <router-view v-slot="{ Component }">
        <component :is="Component" v-if="Component" />
        <assistent-chat-connect-form
            v-else
            v-model="assistent"
        />
    </router-view>
</template>

<script setup lang="ts">
    import type { Assistent } from '@keyvue/one-api-client';
    import { type Ref, ref, watch } from 'vue';
    import AssistentChatConnectForm from '@/ai/assistent/components/forms/AssistentChatConnectForm.vue';

    const props = defineProps<{ modelValue: Assistent }>();
    const emit = defineEmits<{
        (e: 'update:modelValue', value: Assistent): void;
    }>();

    const assistent = ref(props.modelValue) as Ref<Assistent>;

    watch(props.modelValue, (value) => {
        assistent.value = value;
    });

    watch(assistent, (value: Assistent) => {
        emit('update:modelValue', value);
    }, { deep: true });
</script>
